import { useQuery } from "@tanstack/react-query"
import { isAxiosError } from "axios"

import { getOrderByIdFn } from "@/api/ordersApi"
import { showToast } from "@/shared/utils"

export const useFullOrderById = (orderId: string) => {
  const isEnabled = !!orderId && orderId.length > 3

  return useQuery(["fullOrderById", orderId], () => getOrderByIdFn(orderId, true), {
    staleTime: 30 * 1000,
    cacheTime: isEnabled ? 30 * 1000 : 0,
    refetchInterval: 30 * 1000,
    keepPreviousData: true,
    enabled: isEnabled,
    onError: (error) => {
      if (isAxiosError(error)) {
        showToast({
          type: "error",
          text: error.response?.data.errorMessage || error.message,
        })
      }
    },
  })
}
